import React from 'react';
import { MetaPixel } from './components/MetaPixel';
import { Hero } from './components/sections/Hero';
import { Problem } from './components/sections/Problem';
import { Framework } from './components/sections/Framework';
import { Transformation } from './components/sections/Transformation';
import { Volumes } from './components/sections/Volumes';
import { Bonuses } from './components/sections/Bonuses';
import { Offer } from './components/sections/Offer';
import { Testimonials } from './components/sections/Testimonials';
import { Creator } from './components/sections/Creator';
import { Faq } from './components/sections/Faq';
import { FinalCta } from './components/sections/FinalCta';
import { Footer } from './components/sections/Footer';
import { FloatingCta } from './components/FloatingCta';
import { PurchasePopup } from './components/PurchasePopup';
export function App() {
  return <div className="w-full overflow-x-hidden bg-white font-sans text-ink" data-id="element-0" data-mp="23vkvggucm9l8">
      <MetaPixel data-id="element-1" data-mp="23ti8y6semyl9" />
      <Hero data-id="element-2" data-mp="3ik7gwiph6frp" />
      <main data-id="element-3" data-mp="3ikhaeg9qb525">
        <Problem data-id="element-4" data-mp="3iiwdijzxza14" />
        <Framework data-id="element-5" data-mp="3ijfwm41bw4gq" />
        <Transformation data-id="element-6" data-mp="3ihv2gfixenje" />
        <Volumes data-id="element-7" data-mp="3mlj6io8cn0zw" />
        <Bonuses data-id="element-8" data-mp="3ml17jjuay8oa" />
        <Offer data-id="element-9" data-mp="3mkhofzsx1e8o" />
        <Testimonials data-id="element-10" data-mp="3mjztd6hzp62c" />
        <Creator data-id="element-11" data-mp="3mj6hjr46bqdc" />
        <Faq data-id="element-12" data-mp="3rcj6y3gog175" />
        <FinalCta data-id="element-13" data-mp="3rbrcivytg9ig" />
      </main>
      <Footer data-id="element-14" data-mp="3rcsy3udgkeef" />
      <FloatingCta data-id="element-15" data-mp="3rd189ei755lx" />
      <PurchasePopup data-id="element-16" data-mp="5yk6vxnnffx" />
    </div>;
}